import * as FeatureFlagsActions from '../actions/feature-flags.actions';
import * as SystemActions from '../../../store/system/actions/system.actions';

export interface FeatureFlagsState {
  featureFlags: any;
  loading: boolean;
  error: string;
}

export const initialFeatureFlagsState: FeatureFlagsState = {
  featureFlags: null,
  loading: false,
  error: null,
};

export function FeatureFlagsReducer(
  state: FeatureFlagsState = initialFeatureFlagsState,
  action: FeatureFlagsActions.FeatureFlagActions | SystemActions.SystemActions
) {
  switch (action.type) {
    case FeatureFlagsActions.LOAD_FEATURE_FLAGS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FeatureFlagsActions.FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        featureFlags: action.payload,
        loading: false,
        error: null,
      };
    case FeatureFlagsActions.FEATURE_FLAGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SystemActions.CLEAR_SYSTEM:
      return initialFeatureFlagsState;
    default:
      return state;
  }
}
